import { connector } from "../../utils/common/connector";
const controller = "permissionUser";

export const getListModulesByCompanyService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(controller, "GetListModulesByCompany", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const saveUserPermissionsService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.post(controller, "SaveUserPermissions", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const getListUserModulePermissionsByCompanyService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "GetListUserModulePermissionsByCompany",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const getListPermissionsUserModulePermissionsByCompanyService = async (
  params,
) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "GetListPermissionsUserModulePermissionsByCompany",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const changePermissionsUserModeService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "ChangePermissionsUserMode",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};
